var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.participation_class()},[_vm._v(" "+_vm._s((_vm.value*100.00).toFixed(2))+" % ")])}
var staticRenderFns = []

export { render, staticRenderFns }